import React from 'react'
import { EditRuleFlowProvider } from './context/EditRuleFlowProvider'
import { EditRuleFlowMain } from './components/EditRuleFlowMain'

export const EditRuleFlow = () => {
  return (
    <EditRuleFlowProvider>
      <EditRuleFlowMain />
    </EditRuleFlowProvider>
  )
}
